import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';
import {
  closeCreateEmployeeSlotModal,
  createEmployeeSlot,
} from 'state/business/actions';

const CreateEmployeeSlotConfirmationModal = props => {
  const { createEmployeeSlotModal, allBusiness, dispatch } = props;

  const businessId = allBusiness.data[allBusiness.activeIndex].id;

  const handleOnCancelButtonClick = () => {
    dispatch(closeCreateEmployeeSlotModal());
  };

  const handleOnOKButtonClick = () => {
    dispatch(createEmployeeSlot({ businessId }));
    dispatch(closeCreateEmployeeSlotModal());
  };

  return (
    <Modal
      closeIcon
      size="tiny"
      open={createEmployeeSlotModal}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="user" content="Add Employee Slot Confirm" />
      <Modal.Content>
        <p>Are you sure you want to add new employee slot?</p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={handleOnOKButtonClick}>
          OK
        </Button>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ business }) => ({
  createEmployeeSlotModal: business.createEmployeeSlotModal,
  allBusiness: business.allBusiness,
});

CreateEmployeeSlotConfirmationModal.propTypes = {
  createEmployeeSlotModal: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CreateEmployeeSlotConfirmationModal);
